if (!customElements.get('musse-catalogue')) {
  customElements.define('musse-catalogue', class extends HTMLElement {
    connectedCallback() {
      this.filters = this.querySelector('.musse-catalogue__filters');
      this.buttons = [...this.querySelectorAll('[data-filter]')];
      this.cards = [...this.querySelectorAll('[data-musse-family]')];
      this.count = this.querySelector('[role="status"]');
      this.onClick = event => {
        const button = event.target.closest('button[data-filter]');
        if (button && this.filters.contains(button)) this.filter(button.dataset.filter);
      };
      this.filters.addEventListener('click', this.onClick);
      this.filters.hidden = false;
      this.filter('all');
    }
    disconnectedCallback() {
      this.filters?.removeEventListener('click', this.onClick);
    }
    filter(family) {
      let visible = 0;
      this.cards.forEach(card => {
        card.hidden = family !== 'all' && card.dataset.musseFamily !== family;
        if (!card.hidden) visible += 1;
      });
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === family)));
      this.count.textContent = `${visible} ${visible > 1 ? 'modèles' : 'modèle'}`;
      this.querySelector('[data-empty]').hidden = visible !== 0;
    }
  });
}
